// browser Back support for body level layers (lightbox, ref detail, oc viewer): opening one pushes a history entry,
// Back closes the top layer first, and closing it by hand pops its entry so none go stale

interface Layer {
  id: number;
  close: () => void;
}

const layers: Layer[] = [];
let counter = 0;

// call when a layer opens. `close` hides it (it must not call the returned release). The returned release is for closing by button, escape or backdrop
export function pushLayer(close: () => void): () => void {
  const layer: Layer = { id: ++counter, close };
  layers.push(layer);
  try {
    history.pushState({ ...(history.state || {}), layer: layer.id }, "");
  } catch {
    // a sandboxed page can refuse history changes, the layer then just has no Back entry
  }
  return () => {
    const index = layers.indexOf(layer);
    if (index < 0) return;
    layers.splice(index, 1);
    if (history.state?.layer === layer.id) history.back();
  };
}

// popstate hook: true when Back was spent closing a layer
export function popLayers(): boolean {
  const current = history.state?.layer as number | undefined;
  let closed = false;
  while (layers.length && layers[layers.length - 1].id !== current) {
    layers.pop()?.close();
    closed = true;
  }
  return closed;
}

// Forward onto an entry whose layer is gone
export function staleLayerEntry(): boolean {
  const current = history.state?.layer as number | undefined;
  return current !== undefined && !layers.some((layer) => layer.id === current);
}
